import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./ComponenteCSS/Navbar1.scss";
import "bootstrap/dist/css/bootstrap.min.css";

const Navbar1 = () => {
  const [language, setLanguage] = useState("EN");
  const [isActive, setIsActive] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navbarRef = useRef(null);

  const toggleLanguage = () => {
    if (language === "PT") {
      setLanguage("EN");
    } else {
      setLanguage("PT");
    }
  };

  const handleToggle = () => {
    setIsActive(!isActive);
    setExpanded(!expanded);
  };

  const closeMenu = () => {
    setIsActive(false);
    setExpanded(false);
    setDropdownOpen(false);
  };

  const handleDropdownToggle = (isOpen) => {
    setDropdownOpen(isOpen);
  };

  const handleDropdownItemClick = () => {
    setDropdownOpen(false);
    closeMenu();
  };

  // Fechar menu ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        closeMenu();
      }
    };

    if (expanded) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [expanded]);

  // Fechar menu ao redimensionar a tela
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        closeMenu();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navbarItems = {
    EN: {
      escritorio: "Início",
      areasAtuacao: "SERVIÇOS",
      sobreNos: "SOBRE NÓS",
      quemSomos: "QUEM SOMOS",
      processoSeletivo: "SEJA UM DE NÓS",
      cadastro: "CADASTRO",
      contato: "CONTATO",
      linkedin: "LinkedIn",
      agronegocios: "AGRONEGÓCIOS",
      bancarioETransacoesFinanceiras: "BANCARIO E TRANSAÇÕES FINANCEIRAS",
      biocombustiveis: "BIOCOMBUSTÍVEIS",
      contenciosoCivel: "CONTENCIOSO CÍVEL",
      contratos: "CONTRATOS",
      direitoPenalFinanceiro: "DIREITO PENAL FINANCEIRO",
      energiaRenovavel: "ENERGIA RENOVÁVEL",
      familiaESucessoes: "FAMÍLIA E SUCESSÕES",
      gestaoPatrimonial: "GESTÃO PATRIMONIAL",
      litigiosSocietariosEComerciais: "LITÍGIOS SOCIETÁRIOS E COMERCIAIS",
      negociosImobiliarios: "NEGÓCIOS IMOBILIÁRIOS",
      previdenciario: "PREVIDENCIÁRIO",
      propriedadeIntelectual: "PROPRIEDADE INTELECTUAL",
      recuperacaoTributaria: "RECUPERAÇÃO TRIBUTRIA",
      reestruturacaoEInsolvencia: "REESTRUTURAÇÃO E INSOLVÊNCIA",
      relacoesDeConsumo: "RELAÇÕES DE CONSUMO",
      relacoesGovernamentais: "RELAÇÕES GOVERNAMENTAIS",
      saudeEAcessibilidade: "SAÚDE E ACESSIBILIDADE",
      segurosEResseguros: "SEGUROS E RESSEGUROS",
      tecnologia: "TECNOLOGIA",
      trabalhista: "TRABALHISTA",
      tributario: "TRIBUTÁRIO",
      ventureCapitalEStartups: "VENTURE CAPITAL E STARTUPS",
    },
    PT: {
      escritorio: "OFFICE",
      areasAtuacao: "PRACTICE AREAS",
      sobreNos: "ABOUT US",
      quemSomos: "WHO WE ARE",
      processoSeletivo: "CAREERS",
      cadastro: "SIGN UP",
      contato: "CONTACT",
      linkedin: "LinkedIn",
      agronegocios: "AGRICULTURE",
      bancarioETransacoesFinanceiras: "BANKING AND FINANCIAL TRANSACTIONS",
      biocombustiveis: "BIOFUELS",
      contenciosoCivel: "CIVIL LITIGATION",
      contratos: "CONTRACTS",
      direitoPenalFinanceiro: "FINANCIAL CRIMINAL LAW",
      energiaRenovavel: "RENEWABLE ENERGY",
      familiaESucessoes: "FAMILY AND SUCCESSION",
      gestaoPatrimonial: "ASSET MANAGEMENT",
      litigiosSocietariosEComerciais: "CORPORATE AND COMMERCIAL LITIGATION",
      negociosImobiliarios: "REAL ESTATE",
      previdenciario: "SOCIAL SECURITY",
      propriedadeIntelectual: "INTELLECTUAL PROPERTY",
      recuperacaoTributaria: "TAX RECOVERY",
      reestruturacaoEInsolvencia: "RESTRUCTURING AND INSOLVENCY",
      relacoesDeConsumo: "CONSUMER RELATIONS",
      relacoesGovernamentais: "GOVERNMENT RELATIONS",
      saudeEAcessibilidade: "HEALTH AND ACCESSIBILITY",
      segurosEResseguros: "INSURANCE AND REINSURANCE",
      tecnologia: "TECHNOLOGY",
      trabalhista: "LABOR",
      tributario: "TAX",
      ventureCapitalEStartups: "VENTURE CAPITAL AND STARTUPS",
    },
  };

  return (
    <Navbar expand="lg" expanded={expanded} ref={navbarRef}>
      <div className="navbar-wrapper">
        <Navbar.Brand as={Link} to="/">
          <img
            src="/assets/img/logo.png"
            className="logo"
            alt="CQL Advogados"
            title="CQL Advogados"
          />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="menu-items"
          className={`navbar-toggler ${isActive ? "active" : ""}`}
          onClick={handleToggle}
        >
          <div className="navbar-toggler-icon">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </Navbar.Toggle>
        <Navbar.Collapse id="menu-items">
          <Nav className="main-menu">
            <Nav.Link as={Link} to="/" onClick={closeMenu}>
              {navbarItems[language].escritorio}
            </Nav.Link>
            <Nav.Link as={Link} to="/#contact" onClick={closeMenu}>
              {navbarItems[language].contato}
            </Nav.Link>
            <NavDropdown
              title={navbarItems[language].sobreNos}
              id="navbar-about-us"
              show={dropdownOpen}
              onToggle={handleDropdownToggle}
            >
              <Container>
                <NavDropdown.Item
                  as={Link}
                  to="/QuemSomos"
                  onClick={handleDropdownItemClick}
                >
                  {navbarItems[language].quemSomos}
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/QuemSomos#seletiveProcess"
                  onClick={() => {
                    handleDropdownItemClick();
                    setTimeout(() => {
                      const element =
                        document.getElementById("seletiveProcess");
                      if (element) {
                        element.scrollIntoView({ behavior: "smooth" });
                      }
                    }, 100);
                  }}
                >
                  {navbarItems[language].processoSeletivo}
                </NavDropdown.Item>
              </Container>
            </NavDropdown>
            <Nav.Link
              href="https://www.linkedin.com/company/cqladv/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              <img
                src="/assets/img/linkedin-blue.svg"
                className="linkedin"
                alt={navbarItems[language].linkedin}
                title={navbarItems[language].linkedin}
              />
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default Navbar1;
